import { useState, useCallback } from 'react';

// Tracks the current view + the direction the user last navigated.
// Pair with a wrapper whose `key` is the current view — that way React
// remounts the wrapper on each navigation and the CSS animation retriggers.
//
//   <div key={view} className={`view-anim-${direction}`}>{view content}</div>
//
// `direction` is "forward" (slide in from the end side) or "back" (slide in
// from the start side). The classes are direction-only, not LTR/RTL-baked —
// the CSS uses translateX with logical sign so RTL works naturally.
export function useViewTransition(initialView) {
  const [view, setView] = useState(initialView);
  const [direction, setDirection] = useState('forward');

  const navigateTo = useCallback((nextView, dir = 'forward') => {
    setDirection(dir);
    setView(nextView);
  }, []);

  return { view, navigateTo, direction };
}
